import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function GridIcon({ className, width = 20, height = 20 }: IconProps) {
    return (
        <svg
            className={cn('', className)}
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M12.5003 18.9587H7.50033C2.97533 18.9587 1.04199 17.0253 1.04199 12.5003V7.50033C1.04199 2.97533 2.97533 1.04199 7.50033 1.04199H12.5003C17.0253 1.04199 18.9587 2.97533 18.9587 7.50033V12.5003C18.9587 17.0253 17.0253 18.9587 12.5003 18.9587ZM7.50033 2.29199C3.65866 2.29199 2.29199 3.65866 2.29199 7.50033V12.5003C2.29199 16.342 3.65866 17.7087 7.50033 17.7087H12.5003C16.342 17.7087 17.7087 16.342 17.7087 12.5003V7.50033C17.7087 3.65866 16.342 2.29199 12.5003 2.29199H7.50033Z'
                fill='currentColor'
            />
            <path
                d='M18.3331 7.70801H1.69141C1.34974 7.70801 1.06641 7.42467 1.06641 7.08301C1.06641 6.74134 1.34974 6.45801 1.69141 6.45801H18.3331C18.6747 6.45801 18.9581 6.74134 18.9581 7.08301C18.9581 7.42467 18.6747 7.70801 18.3331 7.70801Z'
                fill='currentColor'
            />
            <path
                d='M18.3331 13.542H1.69141C1.34974 13.542 1.06641 13.2587 1.06641 12.917C1.06641 12.5753 1.34974 12.292 1.69141 12.292H18.3331C18.6747 12.292 18.9581 12.5753 18.9581 12.917C18.9581 13.2587 18.6747 13.542 18.3331 13.542Z'
                fill='currentColor'
            />
            <path
                d='M7.0918 18.9498C6.75013 18.9498 6.4668 18.6665 6.4668 18.3248V1.6748C6.4668 1.33314 6.75013 1.0498 7.0918 1.0498C7.43346 1.0498 7.7168 1.33314 7.7168 1.6748V18.3165C7.7168 18.6665 7.4418 18.9498 7.0918 18.9498Z'
                fill='currentColor'
            />
            <path
                d='M12.9248 18.9498C12.5831 18.9498 12.2998 18.6665 12.2998 18.3248V1.6748C12.2998 1.33314 12.5831 1.0498 12.9248 1.0498C13.2665 1.0498 13.5498 1.33314 13.5498 1.6748V18.3165C13.5498 18.6665 13.2748 18.9498 12.9248 18.9498Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default GridIcon;

